import { observable, computed, action, runInAction, makeObservable } from "mobx";
import { VehicleMetaDataModel as VehicleMetaData, VehicleServicePriceInfo } from './ServiceVehicleModel';
import { ApiBasePath } from "../../../utils/ApiBasePath";
import * as Request from "superagent";

export default class ServiceIntervalsModel {
    @observable response: VehicleServicePriceInfo[] = [];
    @observable isIntervalsExist: boolean = false;
    @observable standardQuote: string = '';
    @observable isRegoFetching: boolean = false;
    @observable isVinFetching: boolean = false;
    @observable isRequestError: boolean = false;
    resetDetails: () => void;

    constructor(resetDetails) {
      makeObservable(this);
      this.resetDetails = resetDetails;
    }    
  
    @computed get length() {
      return this.response ? this.response.length : 0;
    }
  
    @action reset = () => {
      this.response = null;
      this.isIntervalsExist = false;
      this.isRegoFetching = false;
      this.isIntervalsExist = false;
      this.isVinFetching = false;
    }

    @action fetchServiceIntervalsByVin = (vinNumber: string) => {
      this.isVinFetching = true;
      let url = `${ApiBasePath.infomedia}/vehicle/${vinNumber}/service-price`;
      Request.get(url).then(
        response => {
          runInAction(() => {
            this.response = response.body;
            this.isVinFetching = false;
            this.isIntervalsExist = true;
            this.isRequestError = false;
          });
        },
        error => {
          runInAction(() => {
            console.log(`An error occurred loading service intervals by vin: ${error}`);
            this.resetDetails();
            this.isRequestError = true;
          });
        }
      );
    };
  }  
